module.exports = __webpack_public_path__ + "static/media/mom1.ce4d0030.jpg";